module.exports = __webpack_public_path__ + "img/empty-pie-chart.2244d157.svg";